import type { TFunction } from 'i18next'

import z from 'zod'

import { AnchorType } from '@/shared/generated'

export const getFormSchema = (t: TFunction) =>
	z.object({
		name: z.string().min(1, { message: 'Please enter a strategy name' }),
		anchor_type: z.enum(Object.values(AnchorType)).default(AnchorType.Flat),
		optimization_group_ids: z.array(z.string()).min(1, {
			message: t(
				'anchoring_management.strategy.validation.optimization_group_required'
			),
		}),
	})
